import { useCallback } from 'react';

export const useScrollToActiveAutomation = (): { scrollToActiveAutomation: (automationId?: string | null) => void } => {
  const isInViewport = (element: HTMLElement): boolean => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  const scrollToActiveAutomation = useCallback((automationId?: string | null): void => {
    const activeListItemElement = document.getElementById('automation-' + automationId);
    if (activeListItemElement && !isInViewport(activeListItemElement))
      activeListItemElement?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }, []);

  return { scrollToActiveAutomation };
};
